import { render, staticRenderFns } from "./document.vue?vue&type=template&id=5fe8f96b&scoped=true&"
var script = {}
import style0 from "./document.vue?vue&type=style&index=0&id=5fe8f96b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8f96b",
  null
  
)

export default component.exports